"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var colors_1 = require("../../constants/colors");
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../../utils");
var Method = styled_components_1.default(AXSBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-color: ", ";\n  border-width: 2px;\n  border-style: solid;\n  border-radius: 4px;\n  color: ", ";\n  cursor: ", ";\n\n  &:first-of-type {\n    margin-left: 0;\n  }\n"], ["\n  border-color: ",
    ";\n  border-width: 2px;\n  border-style: solid;\n  border-radius: 4px;\n  color: ", ";\n  cursor: ", ";\n\n  &:first-of-type {\n    margin-left: 0;\n  }\n"])), function (_a) {
    var active = _a.active, activeBorderColor = _a.activeBorderColor, borderColor = _a.borderColor, theme = _a.theme;
    return active
        ? utils_1.parseThemePath(activeBorderColor, theme, colors_1.colors.BLUE_300)
        : utils_1.parseThemePath(borderColor, theme, colors_1.colors.GREY_350);
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, colors_1.colors.GREY_650);
}, function (_a) {
    var readOnly = _a.readOnly;
    return readOnly ? 'default' : 'pointer';
});
var AXSPaymentMethodSelector = function (_a) {
    var id = _a.id, label = _a.label, handleToggle = _a.handleToggle, active = _a.active, color = _a.color, borderColor = _a.borderColor, activeBorderColor = _a.activeBorderColor, className = _a.className, readOnly = _a.readOnly, props = __rest(_a, ["id", "label", "handleToggle", "active", "color", "borderColor", "activeBorderColor", "className", "readOnly"]);
    return (React.createElement(Method, __assign({ active: active, activeBorderColor: activeBorderColor, borderColor: borderColor, borderRadius: "4px", color: color, height: "64px", marginRight: "10px", marginBottom: "10px", key: "pms" + id, onClick: function () { return (readOnly ? undefined : handleToggle(id)); }, padding: "8px", readOnly: readOnly, width: "200px" }, props, { className: classnames_1.default(['c-axs-delivery-method-selector', className]) }),
        React.createElement(AXSFlex_1.default, { alignItems: "flex-start", justifyContent: "space-between" },
            React.createElement(AXSBlock_1.default, { fontSize: "14px" }, label))));
};
AXSPaymentMethodSelector.defaultProps = {
    active: false,
    activeBorderColor: 'axsui.components.paymentMethodSelector.activeBorderColor',
    borderColor: 'axsui.components.paymentMethodSelector.borderColor',
    color: 'axsui.components.paymentMethodSelector.color',
    readOnly: false,
    width: '200px',
};
exports.default = AXSPaymentMethodSelector;
var templateObject_1;
//# sourceMappingURL=index.js.map